import { render } from "./References.vue?vue&type=template&id=091d2f59&scoped=true&ts=true"
import script from "./References.vue?vue&type=script&lang=ts"
export * from "./References.vue?vue&type=script&lang=ts"

import "./References.vue?vue&type=style&index=0&id=091d2f59&scoped=true&lang=css"
import "./References.vue?vue&type=style&index=1&id=091d2f59&lang=css"

import exportComponent from "/home/bwhite/Projects/bryanchriswhite-com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-091d2f59"]])

export default __exports__